/**
 * Drive 2.0 als Single-Page-App unter `/drive` (#504).
 *
 * Gegenstück zu `StandaloneChatPage`: dieselbe Drive-Implementierung wie im
 * Desktop-Fenster, ohne Shell. Navigation und `AppHost` kommen vom
 * `StandaloneLayout` — dadurch landet Drives „an den Communicator anhängen"
 * hier auf `/chat` statt in einem Fenster.
 */
import { Suspense, lazy } from 'react'
import { Loader2 } from 'lucide-react'

const Drive2App = lazy(() => import('@/components/applications/drive2/Drive2App'))

export function StandaloneDrivePage() {
  return (
    <div className="app-surface h-full overflow-hidden">
      <Suspense
        fallback={
          <div className="flex h-full w-full items-center justify-center">
            <Loader2 className="h-6 w-6 animate-spin motion-reduce:animate-none text-[var(--text-secondary)]" />
          </div>
        }
      >
        <Drive2App />
      </Suspense>
    </div>
  )
}
